<template>
  <div class="apply-step apply-step--terminal">
    <div class="apply-step__icon">👋</div>
    <h2>Tu proceso fue cerrado</h2>
    <p>Registramos que decidiste no continuar con el proceso. Si cambias de opinión, escríbenos y con gusto te ayudamos a retomarlo.</p>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'ResultRetirado',
  mounted() { this.clearAll() },
  methods: { ...mapActions('apply', ['clearAll']) },
}
</script>

<style src="../apply-step.css" scoped></style>
<style scoped>
.apply-step--terminal { text-align: center; padding: 2rem 1rem; }
.apply-step__icon { font-size: 4rem; margin-bottom: 1rem; }
</style>
